module.exports = __webpack_public_path__ + "img/sudafed_pe_head_congestion_mucus_non_drowsy_relief_tablets.be5f2d47.png";